import { Map, List } from 'immutable';

import {
  PLANNER_TO_DO_USER_LIST_REQUEST,
  PLANNER_TO_DO_USER_LIST_SUCCESS,
  PLANNER_TO_DO_USER_LIST_FAILURE,
  PLANNER_TO_DO_USER_READ_REQUEST,
  PLANNER_TO_DO_USER_READ_SUCCESS,
  PLANNER_TO_DO_USER_READ_FAILURE,
  PLANNER_TO_DO_USER_UPDATE_REQUEST,
  PLANNER_TO_DO_USER_UPDATE_SUCCESS,
  PLANNER_TO_DO_USER_UPDATE_FAILURE,
  PLANNER_TO_DO_USER_CREATE_REQUEST,
  PLANNER_TO_DO_USER_CREATE_SUCCESS,
  PLANNER_TO_DO_USER_CREATE_FAILURE,
  PLANNER_TO_DO_USER_DELETE_REQUEST,
  PLANNER_TO_DO_USER_DELETE_SUCCESS,
  PLANNER_TO_DO_USER_DELETE_FAILURE,
  PLANNER_TO_DO_USER_FORM_DESTROY,
  PLANNER_TO_DO_USER_CSV_DOWNLOAD_REQUEST,
  PLANNER_TO_DO_USER_CSV_DOWNLOAD_SUCCESS,
  PLANNER_TO_DO_USER_CSV_DOWNLOAD_FAILURE
} from './actions'
import Logger from '../../../lib/Logger';

export default function plannerToDosUser(
  state = Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {}
  }),
  action
) {
  Logger.log('debug', `[plannerToDosUser.reducers] plannerToDosUser(%j, %j)`, state, action);

  switch (action.type) {

    case PLANNER_TO_DO_USER_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case PLANNER_TO_DO_USER_LIST_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        pages: {
          [action.order]: {
            [action.limit]: {
              [action.page]: null
            }
          }
        },
        total: action.total,
        lastUpdated: action.receivedAt
      }).setIn(['pages', action.order, action.limit, action.page], List(action.result));

    case PLANNER_TO_DO_USER_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case PLANNER_TO_DO_USER_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case PLANNER_TO_DO_USER_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case PLANNER_TO_DO_USER_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case PLANNER_TO_DO_USER_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null
        }
      });

    case PLANNER_TO_DO_USER_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null
        },
        lastUpdated: action.receivedAt
      });

    case PLANNER_TO_DO_USER_UPDATE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: false,
          errors: null
        }
      }).setIn(['form', 'errors'], action.error);

    case PLANNER_TO_DO_USER_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null
        }
      });

    case PLANNER_TO_DO_USER_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null
        },
        lastUpdated: action.receivedAt
      });

    case PLANNER_TO_DO_USER_CREATE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: false,
          errors: null
        }
      }).setIn(['form', 'errors'], action.error);

    case PLANNER_TO_DO_USER_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case PLANNER_TO_DO_USER_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case PLANNER_TO_DO_USER_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case PLANNER_TO_DO_USER_FORM_DESTROY:
      return state.mergeDeep({
        form: null
      }).set('form', action.form);

    case PLANNER_TO_DO_USER_CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true
      });

    case PLANNER_TO_DO_USER_CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case PLANNER_TO_DO_USER_CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    default:
      return state;
  }
}

Logger.log('silly', `plannerToDosUser.reducers loaded.`);
